webpackJsonp([35783957827783],{

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderRainbow = function HeaderRainbow() {
	  return _react2.default.createElement('div', { className: 'header-diagonal rainbow' });
	};
	
	exports.default = HeaderRainbow;
	module.exports = exports['default'];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unicorn = __webpack_require__(114);
	
	var _unicorn2 = _interopRequireDefault(_unicorn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Unicorn = function Unicorn() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('img', { className: 'unicorn-bg-image', src: _unicorn2.default })
	  );
	};
	
	exports.default = Unicorn;
	module.exports = exports['default'];

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/art-dyb-1.08eeedd3.png";

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/art-txt-3.250db87a.svg";

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/critiques.9d8d2030.png";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dyb-poster-set.bd93adf8.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/everybody.70ea21a7.jpg";

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE1MCIgaGVpZ2h0PSIyNDgiIHZpZXdCb3g9IjAgMCAxMTUwIDI0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExNDkuNDkgMjQ4TDAuNTEwNzA4IDUuMzk0MjJlLTA2SDExNDkuNDlWMjQ4WiIgZmlsbD0iIzE5MUQyRiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/unicorn.873fbf2f.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/writing-business-software.ff5dba89.jpg";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/writing-process.7211cc24.jpg";

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ProjectCards = __webpack_require__(117);
	
	var _ProjectCards2 = _interopRequireDefault(_ProjectCards);
	
	var _BackNav = __webpack_require__(15);
	
	var _BackNav2 = _interopRequireDefault(_BackNav);
	
	var _HeaderRainbow = __webpack_require__(68);
	
	var _HeaderRainbow2 = _interopRequireDefault(_HeaderRainbow);
	
	var _Unicorn = __webpack_require__(69);
	
	var _Unicorn2 = _interopRequireDefault(_Unicorn);
	
	var _sliceTop = __webpack_require__(179);
	
	var _sliceTop2 = _interopRequireDefault(_sliceTop);
	
	var _sliceBottom = __webpack_require__(499);
	
	var _sliceBottom2 = _interopRequireDefault(_sliceBottom);
	
	var _critiques = __webpack_require__(453);
	
	var _critiques2 = _interopRequireDefault(_critiques);
	
	var _writingProcess = __webpack_require__(503);
	
	var _writingProcess2 = _interopRequireDefault(_writingProcess);
	
	var _writingBusinessSoftware = __webpack_require__(502);
	
	var _writingBusinessSoftware2 = _interopRequireDefault(_writingBusinessSoftware);
	
	var _artTxt = __webpack_require__(446);
	
	var _artTxt2 = _interopRequireDefault(_artTxt);
	
	var _dybPosterSet = __webpack_require__(481);
	
	var _dybPosterSet2 = _interopRequireDefault(_dybPosterSet);
	
	var _artDyb = __webpack_require__(445);
	
	var _artDyb2 = _interopRequireDefault(_artDyb);
	
	var _everybody = __webpack_require__(482);
	
	var _everybody2 = _interopRequireDefault(_everybody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Work Thumbnails
	// import workGustoDocuments from '../images/work-gusto-documents.jpg'
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HeaderRainbow2.default, null),
	    _react2.default.createElement(_Unicorn2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'half-page main' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'huge-text' },
	        '\uD83E\uDD84 Hi, I\'m Will'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'indent half-page' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'I create experiences that people ',
	            _react2.default.createElement(
	              'span',
	              { className: 'love' },
	              'love'
	            ),
	            '.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Most recently I worked with several teams at ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://gusto.com' },
	            'Gusto'
	          ),
	          ', designing new financial products for employees.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Previously I worked with a talented team to create a DJ app that people love called ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.facebook.com/crossfaderapp/' },
	            'Crossfader'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I designed a little app ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'http://breatheapp.co/' },
	            'Breathe'
	          ),
	          ' to help people practice mindfulness, which ',
	          _react2.default.createElement(
	            'i',
	            null,
	            '(funny story!)'
	          ),
	          ' is ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://observer.com/2016/12/apple-watch-rips-off-silicon-valley-developers-iphone-breathe-app/' },
	            'no longer around.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Nights and weekends I make make dance music with my record label ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'http://pizzaandtechno.com' },
	            'Pizza & Techno'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'block-slice' },
	      _react2.default.createElement('img', { src: _sliceTop2.default, className: 'top-slice-svg' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rainbow block' },
	      _react2.default.createElement(
	        'div',
	        { id: 'work', className: 'main white-text' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'huge-text' },
	          'Selected work:'
	        ),
	        _react2.default.createElement(_ProjectCards2.default, null),
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://dribbble.com/willdjthrill', className: 'more-link' },
	          'see more pixels on dribbble'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'main white-text margin-top-50 padding-bottom-50' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'margin-none huge-text' },
	          ' Writing '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-holder' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://medium.com/gusto-design/getting-the-most-out-of-design-critiques-dea20f7425d' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card first-card' },
	              _react2.default.createElement('img', { className: 'card-img', src: _critiques2.default }),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Getting the most out of design critiques'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://medium.com/@willdjthrill/waiting-for-a-sign-to-start-building-your-design-teams-component-library-c43f4352c764' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card second-card' },
	              _react2.default.createElement('img', { className: 'card-img', src: 'https://cdn-images-1.medium.com/max/2000/1*3mOZuMo4ap1NfW3ugn93ng.png' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'The beginnings of our design system'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://medium.com/@willdjthrill/designing-delightful-business-software-51612a9f2f' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card third-card' },
	              _react2.default.createElement('img', { className: 'card-img', src: _writingBusinessSoftware2.default }),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Designing Delightful Business Software'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://medium.freecodecamp.org/the-design-process-a-pyramid-c77135c177d4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card fourth-card' },
	              _react2.default.createElement('img', { className: 'card-img', src: _writingProcess2.default }),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                ' The Design Process: A Pyramid'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://medium.com/@willdjthrill', className: 'more-link' },
	          'follow on Medium'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'block-slice' },
	      _react2.default.createElement('img', { src: _sliceBottom2.default, className: 'bottom-slice-svg' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'half-page main unicorn-text' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'huge-text' },
	        _react2.default.createElement(
	          'i',
	          null,
	          'Unicorns',
	          _react2.default.createElement('br', null),
	          'exist.'
	        ),
	        _react2.default.createElement('br', null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'block-slice unicorn-text' },
	      _react2.default.createElement('img', { src: _sliceTop2.default, className: 'top-slice-svg' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rainbow block padding-bottom-50' },
	      _react2.default.createElement(
	        'div',
	        { className: 'main white-text' },
	        _react2.default.createElement(
	          'h1',
	          { className: '' },
	          'Elsewhere online:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-links-list bigger' },
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://twitter.com/willdjthrill' },
	            'Twitter'
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://dribbble.com/willdjthrill' },
	            'Dribbble'
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://medium.com/@willdjthrill' },
	            'Medium'
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://instagram.com/wow_willnewton' },
	            'Instagram'
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://soundcloud.com/djwillaa' },
	            'Soundcloud'
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://mixcloud.com/willaa' },
	            'Mixcloud'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer-subtext white-text text-center' },
	        _react2.default.createElement(
	          'p',
	          null,
	          '\xA9 William Newton 2020   |   Handwritten by myself using ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', className: 'white-text', href: 'https://www.gatsbyjs.org/' },
	            'GatsbyJS'
	          )
	        )
	      )
	    )
	  );
	};
	
	// Art images
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e3b8868140770cf03196.js